/* eslint-disable */
import CpqConstraint from '@ali/common-cpq-constraint';
import { getBuyUrl } from '../services/buy';
import xor from 'lodash.xor';
import unionWith from 'lodash.unionwith';
/** 产品基类 */
export default class Base {
  buyUrl;
  hasSetValue = false; // 是否修改过配置
  constructor(goods) {
    let me = this;

    //依赖数组
    me._dependencies = [];

    me.goods = Object.assign({}, goods);

    me.commodityCode = goods.commodityCode;
    //标准选配模型参数
    me.accessories = goods.accessories || {};

    //格式化commodity的值
    me.formatValue(me.accessories);

    //活动Id
    me.activityId = goods.activityId;

    this.setConfig(me.commodityValue);

  }

  //根据code是否匹配该产品
  match(code, accessories) {
    return this.commodityCode === code;
  }

  //格式化值
  formatValue(accessories) {
    let commodity = {}, defaultValue = accessories.defaultValues && accessories.defaultValues[0];

    Object.keys(accessories.commodity).forEach(key => {
      let item = accessories.commodity[key];

      if (item != null) {
        let value = typeof item === 'object' ? item.value : item;

        // if(item.defaultValue != null) {
        //   commodityValue[key] = defaultValue;
        // } else {
        //当为数组时取, 默认取第一个
        commodity[key] = Array.isArray(value) ? value[0] : value;

        // if (typeof value === 'object') {
        //   commodityValue[key] = value.value != null ? value.value : value.defaultValue;
        // } else {
        //   commodityValue[key] = value;
        // }
        // }
      }
    });


    this.commodityValue = defaultValue;
    this.commodity = commodity;

    // console.log(JSON.stringify(defaultValue) );
  }

  //格式化时长
  formatPeroid(commodity, config) {
    let time = commodity.order_time || commodity.ord_time;
    if (time) {
      let [number, type] = time.split(':');

      this.setPeroid(config, number, type);
    }
  }

  addDependencies(dependence) {
    this._dependencies.push(dependence);
  }

  resoveDependencies() {
    // let des = [];
    // this._dependencies.forEach((check) => {
    //   var result = check();
    //   result && des.push(result);
    // })

    // return Promise.all(des);

    return Promise.all(this._dependencies);
  }

  //执行操作的方法，会先解析依赖函数
  execute(fn) {
    let me = this;
    fn.bind(this);

    return new Promise((resolve) => {
      me.resoveDependencies().then(() => {
        this._dependencies = [];

        let result = fn();
        if (result && result.then) {
          result.then((value) => {
            resolve(value);
          });
        } else {
          resolve(result);
        }

      });
    });
  }

  //设置时长 setPeroid(number, type)
  setPeroid() {

  }

  //获取格式化后的数量
  formatQuantity(config) {
    config = config || this.commodityValue;
    return config.order_num || config.ord_num || config.quantity || 1;
  }

  //获取默认值
  getDefaultConfig() {
    return {};
  }

  //获取基本配置
  getConfig(commodityValue) {
    let config = Object.assign({}, commodityValue || this.commodityValue);
    return config;
  }
  // 设置配置项可选值，用于约束调整
  _setOptions(config, queryKeys) {
    const newOptions = Object.keys(this.accessories.commodity).map(key => {
      const target = this.accessories.commodity[key];
      let value = target.options;
      if (queryKeys.some(elem => elem == key)) {
        // 对于当前选中配置的项，不去调整它的约束
        if (this._options) {
          value = this._options.find(elem => elem.key == key).value;
        }
      }
      if (config[key]) {
        // 使用约束里提供的配置
        value = config[key];
        // console.warn(`${key}需要调整，内容平台配置为`, value, `约束返回的的value为`, config[key], '两者需要进行合并');
        const newValue = unionWith(value, config[key], (a, b) => {
          return a.value == b.value;
        });
        // console.warn('合并后的值为', newValue);
        value = newValue;
      }
      return {
        label: target.name,
        key: target.code,
        value: value
      }
    });
    this._options = newOptions;
  }
  // 获得配置项可选值
  getOptions() {
    if (this._options) {
      return this._options;
    }
    const _options = Object.keys(this.accessories.commodity).map(key => {
      const target = this.accessories.commodity[key];
      return {
        label: target.name,
        key: target.code,
        value: target.options
      }
    });
    this._options = _options;
    return this._options;
  }
  //设置配置项
  setConfig(commodityValue) {
    let me = this;
    me.commodityValue = commodityValue;
    if (commodityValue) {
      //各产品配置参数
      me.config = me.getConfig();
      me.formatPeroid(commodityValue, me.config);
      me.formatQuantity(commodityValue, me.config);
      // 修改默认参数
      me.accessories.defaultValues = [me.getValue()]
    }
    else {
      me.config = {};
    }

    me.setBusinessInf(me.config);
    return me;
  }

  setBusinessInf(config, name) {
    let businessInfo = config[name || 'businessInfo'] = {};

    this.activityId && (businessInfo.order_activity_id = this.activityId);
    // businessInfo.aliyun_shopcart_order_source = 'fromShopcart';
  }

  // 设置配件值，需要先获取约束，重新调整Options和配置
  async setValueWithConstranit(value = {}) {
    const nowValue = this.getValue();
    Object.assign(nowValue, value);
    delete nowValue.price;
    const queryKeys = Object.keys(value);
    const allKeys = Object.keys(nowValue);
    const targetKeys = xor(queryKeys, allKeys);
    const constraintOptions = {
      commodityCode: this.commodityCode,
      specCode: this.commodityCode,
      anonymous: true,
      targetFieldCodes: targetKeys, //需要获取的商品规格code
      fieldValues: nowValue
    };
    const options = await CpqConstraint.getOptions(constraintOptions)

    for (const key in options) {
      if (options.hasOwnProperty(key)) {
        if (queryKeys.some(elem => elem == key)) {
          delete options[key];
        }
      }
    }
    for (const key in nowValue) {
      if (!['ord_time', 'order_num'].concat(queryKeys).some(elem => elem == key)) {
        const element = nowValue[key];
        // 如果当前值在约束内，不动，如果不在，则调整，调整为第一项
        if (options[key]) {
          if (options[key].some(elem => elem.value == element)) {
          } else {
            // console.warn(key, '的值', element, '不符合约束，进行调整，调整为', options[key]);
            nowValue[key] = options[key][0] ? options[key][0].value : '';
          }
        }
      }
    }
    this.setConfig(nowValue);
    // 调整可选项
    this._setOptions(options, queryKeys);
    this.hasSetValue = true;
    return this;
  }
  // replace 设置为true时，表示完全进行替换，而非混合模式
  setValue(value, replace = false) {
    this.hasSetValue = true;
    if (replace) {
      this.setConfig(value);
    } else {
      this.setConfig(Object.assign(this.getValue(), value));
    }
    return this;
  }
  //获取默认值
  getValue(key) {
    const value = Object.assign({}, this.commodityValue);
    if (key) {
      return value[key];
    } else {
      return value;
    }
  }

  //获取去buy页面配置
  getBuyConfig() {
    return Object.assign({}, this.commodityValue);
  }

  //获取buy页面地址
  getBuyUrl() {
    return this.execute(() => {
      if (this.buyUrl) {
        //先执行获取config，中间可能存在对 buyUrl的调整；
        let buyConfig = this.getBuyConfig();
        return getBuyUrl(this.buyUrl, buyConfig);
      }
      return '';
    });
  }

  //获取购物车配置
  getCartConfig() {
    return null;
  }

  //添加到购物车
  addCart() {
    return null;
  }

  //获取询价配置
  getPriceConfig(config) {
    return null;
  }

  //获取价格
  getPrice(params) {
    return null;
  }

  //获取全部价格
  getAllPrice(params) {
    return null;
  }

  //获取弹窗选配配置
  getPopupBuyConfig(popUpConfig) {
    return null;
  }

  //打开选配框
  popUpBuy(popUpConfig) {
    return null;
  }

  //获取下单配置
  getOrderConfig() {
    return null;
  }

  //获取订单url
  getOrderUrl() {
    return null;
  }
}




// WEBPACK FOOTER //
// ./lib/services/product/base.js